import {QueryInput} from "@dynamoit/shared/generated/globalTypes";
import {QueryModel, TypesModel} from "@/types";

export const REGIONS = [
    {name: "us-east-1", title: "US East (N. Virginia)"},
    {name: "us-east-2", title: "US East (Ohio)"},
    {name: "us-west-1", title: "US West (Northern California)"},
    {name: "us-west-2", title: "US West (Oregon)"},
    {name: "af-south-1", title: "Africa (Cape Town)"},
    {name: "ap-east-1", title: "Asia Pacific (Hong Kong)"},
    {name: "ap-south-1", title: "Asia Pacific (Mumbai)"},
    {name: "ap-northeast-3", title: "Asia Pacific (Osaka)"},
    {name: "ap-northeast-2", title: "Asia Pacific (Seoul)"},
    {name: "ap-southeast-1", title: "Asia Pacific (Singapore)"},
    {name: "ap-southeast-2", title: "Asia Pacific (Sydney)"},
    {name: "ap-northeast-1", title: "Asia Pacific (Tokyo)"},
    {name: "ca-central-1", title: "Canada (Central)"},
    {name: "eu-central-1", title: "Europe (Frankfurt)"},
    {name: "eu-west-1", title: "Europe (Ireland)"},
    {name: "eu-west-2", title: "Europe (London)"},
    {name: "eu-south-1", title: "Europe (Milan)"},
    {name: "eu-west-3", title: "Europe (Paris)"},
    {name: "eu-north-1", title: "Europe (Stockholm)"},
    {name: "me-south-1", title: "Middle East (Bahrain)"},
    {name: "sa-east-1", title: "South America (Sao Paulo)"},
    {name: "us-gov-east-1", title: "AWS GovCloud (US-East)"},
    {name: "us-gov-west-1", title: "AWS GovCloud (US-West)"}
]

export function queryModelToQueryInput({hash, range, criteria}: QueryModel, typesModel: TypesModel): QueryInput {
    return {
        hash,
        range,
        criteria: Object.values(criteria).map(_ => ({
            ..._,
            value: JSON.stringify({
                data: typesModel[_.property] === 'number' ? Number(`${_.value.data}`) : _.value.data
            })
        }))
    }
}

export function queryInputToQueryModel({hash, range, criteria}: QueryInput): QueryModel {
    return {
        hash,
        range: range || undefined,
        criteria: criteria.reduce((acc, val) => ({
            ...acc,
            [val.property]: val
        }), {})
    }
}

export function isArray(val: any): boolean {
    if (val) {
        return val.constructor.name === 'Array'
    }
    return false
}
